import React, { CSSProperties } from 'react';
import styled from 'styled-components';
import { Typography } from 'antd';

import { ReactComponent as CalendarIcon } from 'app/assets/img/calendar.svg';

const { Paragraph } = Typography;

interface Props {
  value?: string | undefined;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  placeholder?: string;
  onChange?: (value: string) => void;
  className?: string;
  calendarIconCSS?: {
    pathCSS?: CSSProperties;
  };
  containerCSS?: CSSProperties;
}

const DatePickerInput: React.FC<Props> = ({
  value,
  onClick,
  placeholder,
  className,
  calendarIconCSS,
  containerCSS,
}) => (
  <Container onClick={onClick} className={className} style={containerCSS}>
    <StyledParagraph ellipsis={{ rows: 1 }}>
      {value ?? placeholder}
    </StyledParagraph>
    <StyledCalendarIcon pathCSS={calendarIconCSS?.pathCSS} />
  </Container>
);

export default DatePickerInput;

const Container = styled.div`
  cursor: pointer;
  height: 45px;
  width: 350px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  @media (max-width: 1399px) {
    width: 250px;
  }
`;

const StyledParagraph = styled(Paragraph)`
  &.ant-typography {
    font-family: Be Vietnam Pro, sans-serif;
    font-weight: 400;
    margin: 0;
    width: calc(100% - 24px);
  }
`;

const StyledCalendarIcon = styled(CalendarIcon)<{ pathCSS?: CSSProperties }>`
  position: absolute;
  right: 16px;
  top: 50%;
  flex-shrink: 0;
  transform: translateY(-50%);
  cursor: pointer;
  path {
    ${props => ({ ...props.pathCSS })}
  }
`;
